import { Agent } from '../../../domain/agents/models/Agent';

export interface AgentsState {
    byId: Record<string, Agent>;
    allIds: string[];
}

export const initialAgentsState: AgentsState = {
    byId: {},
    allIds: [],
};
